import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosInstance";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { logout } from "../../Api/auth";
import { useNavigate } from "react-router-dom";
import FormError from "./FormError";

const DeleteAccount = () => {
  const { t, i18n } = useTranslation();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [countdown, setCountdown] = useState(3);

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    if (e.target.value !== "other") {
      setCustomReason("");
    }
  };

  const handleDeactivate = async () => {
    if (!reason || (reason === "other" && !customReason)) {
      setError(t("Please select a reason for deletion."));
      return;
    }
    setError("");

    try {
      const payload = {
        reason: reason === "other" ? customReason : reason,
        body: t("User requested account deletion"),
      };

      await axiosInstance.delete("/api/v1/profile/delete-account", {
        data: payload,
        headers: {
          "Content-Type": "application/json",
        },
      });

      toast.success(t("Your account deletion request has been sent."));
      setShowModal(false); // إغلاق مودال الحذف
      setShowLogoutModal(true); // عرض مودال التأكيد

      logout(); // تسجيل الخروج

      setTimeout(() => {
        setShowLogoutModal(false);
        window.location.href = "/";
      }, 3000);

      setShowModal(false);
    } catch (error) {
      toast.error(t("Failed to delete account. Please try again."));
    }
  };

  useEffect(() => {
    if (showLogoutModal && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [showLogoutModal, countdown]);

  return (
    <div dir={direction}>
      <Alert variant="warning">
        {t(
          "Delettion your account is permanent. Please make sure you want to proceed."
        )}
      </Alert>
      <Button variant="danger" onClick={() => setShowModal(true)}>
        {t("Delettion Account")}
      </Button>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton dir={direction}>
          <Modal.Title>{t("Delettion Account")}</Modal.Title>
        </Modal.Header>
        <Modal.Body dir={direction}>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group
            controlId="deactivationReason"
            // className={direction === "rtl" ? "text-end" : ""}
          >
            <Form.Label>{t("Reason for deactivation:")}</Form.Label>

            <Form.Check
              className={direction === "rtl" ? "text-end pe-2" : ""}
              type="radio"
              id="reason1"
              label={t("I signed up by mistake")}
              name="deactivationReason"
              value="Signed up by mistake"
              checked={reason === "Signed up by mistake"}
              onChange={handleReasonChange}
            />

            <Form.Check
              className={direction === "rtl" ? "text-end pe-2" : ""}
              type="radio"
              id="reason2"
              label={t("I don't use this service anymore")}
              name="deactivationReason"
              value="No longer using the service"
              checked={reason === "No longer using the service"}
              onChange={handleReasonChange}
            />

            <Form.Check
              className={direction === "rtl" ? "text-end pe-2" : ""}
              type="radio"
              id="reason3"
              label={t("Other")}
              name="deactivationReason"
              value="other"
              checked={reason === "other"}
              onChange={handleReasonChange}
            />

            {reason === "other" && (
              <Form.Control
                type="text"
                placeholder={t("Please specify...")}
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
              />
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer dir={direction}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("Cancel")}
          </Button>
          <Button variant="danger" onClick={handleDeactivate}>
            {t("Confirm Deactivation")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        backdrop="static"
        keyboard={false}
        centered
        dir={direction}
      >
        <Modal.Header>
          <Modal.Title>{t("Account Deleted")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            {t("You will be logged out in")} {countdown} {t("seconds...")}
          </p>
          <div className="spinner-border text-danger mt-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer autoClose={3000} />
    </div>
  );
};

export default DeleteAccount;
